import { Route } from 'react-router-dom';

import { PrivateRoute } from './user.utils';

import examplesRouteGroup from './groups/examples.routes';

import MainScreen from 'src/screens/main/main.component';

const userRoutes = (
  <Route path="painel">
    <Route index element={<PrivateRoute children={<MainScreen />} />} />
    {examplesRouteGroup}
  </Route>
);

export default userRoutes;
